import { memo as Memo, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const RollyJump = Memo(({ animate }) => {
	const svgRef = useRef(null);
	const leftRef = useRef(null);
	const rightRef = useRef(null);
	const animRef = useRef(null);

	useEffect(() => {
		const tl = gsap.timeline({ paused: true });

		tl.to(svgRef.current, { duration: 0.2, y: -20 })
			.to(leftRef.current, { duration: 0.2, svgOrigin: '51 115', rotation: 30 }, 0)
			.to(rightRef.current, { duration: 0.2, svgOrigin: '73 115', rotation: -30 }, 0)
			.to(svgRef.current, { duration: 0.2, y: 0 }, 0.2)
			.to(leftRef.current, { duration: 0.2, svgOrigin: '51 115', rotation: 0 }, 0.2)
			.to(rightRef.current, { duration: 0.2, svgOrigin: '73 115', rotation: 0 }, 0.2);

		animRef.current = tl;

		return () => {
			tl.kill();
			animRef.current = null;
		};
	}, []);

	useEffect(() => {
		if (animate && animRef.current) {
			animRef.current.progress(0).play();
		}
	}, [animate]);

	return (
		<svg
			ref={svgRef}
			className='svg-max rollyJump'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 133.27 162.36'>
			<circle
				className='fill'
				cx='66.64'
				cy='66.64'
				r='66.64'
			/>
			<path
				ref={leftRef}
				className='rollyJump-fl defaultStyle'
				d='M51.35,115.07c-.53,6-1.72,22.21-2.57,32.49a13,13,0,0,1-9.26,11.38l-5.63,1.67'
			/>
			<path
				ref={rightRef}
				className='rollyJump-fr defaultStyle'
				d='M73.89,115.07c.54,6,1.72,22.21,2.58,32.49a13,13,0,0,0,9.26,11.38l5.62,1.67'
			/>
		</svg>
	);
});

export default RollyJump;
